module.exports = __webpack_public_path__ + "img/menu2.184983c7.png";